{
  "REPORT": {
    "HEADER": "Gesprekken",
    "LOADING_CHART": "Kaartgegevens laden...",
    "NO_ENOUGH_DATA": "We hebben niet genoeg datapunten ontvangen om een rapport te genereren, probeer het later opnieuw.",
    "DOWNLOAD_AGENT_REPORTS": "Medewerkerrapporten downloaden",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Gesprekken",
        "DESC": "( Totaal )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkomende berichten",
        "DESC": "( Totaal )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Uitgaande berichten",
        "DESC": "( Totaal )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Eerste reactietijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Eerste Reactie Tijd is {metricValue} (gebaseerd op {conversationCount} gesprekken)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolutie Tijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( Totaal )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "Vandaag",
      "YESTERDAY": "Gisteren",
      "LAST_7_DAYS": "Afgelopen 7 dagen",
      "LAST_30_DAYS": "Laatste 30 dagen",
      "THIS_MONTH": "Deze maand",
      "LAST_MONTH": "Vorige maand",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Geen resultaten gevonden"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Gesprekken: {count}",
      "RESULT_COUNT_MESSAGE": "Berichten: {count}",
      "EMPTY": "Geen records gevonden voor deze balk.",
      "ERROR": "Records konden niet worden geladen. Probeer het opnieuw.",
      "LOAD_MORE": "Meer laden",
      "PREVIOUS_BUCKET": "Vorige balk",
      "NEXT_BUCKET": "Volgende balk",
      "UNKNOWN_CONTACT": "Onbekend contact",
      "UNKNOWN_INBOX": "Onbekende inbox",
      "UNASSIGNED_AGENT": "Niet toegewezen",
      "NO_MESSAGE_CONTENT": "Geen berichtinhoud",
      "MESSAGE_CREATED_AT": "Bericht aangemaakt op {time}",
      "EVENT_OCCURRED_AT": "Gebeurtenis vond plaats op {time}",
      "INCOMING_MESSAGE": "Inkomend bericht",
      "OUTGOING_MESSAGE": "Uitgaand bericht",
      "VIEW_ALL": "Bekijken in gesprekken",
      "VIEW_ALL_LIMIT": "Alleen balken met maximaal {limit} gesprekken openen in de gesprekkenlijst.",
      "HIDDEN_COUNT": "Niet getoond omdat je geen lid bent van hun inbox: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Kaartgegevens laden...",
    "NO_ENOUGH_DATA": "We hebben niet genoeg datapunten ontvangen om een rapport te genereren, probeer het later opnieuw.",
    "DOWNLOAD_AGENT_REPORTS": "Medewerkerrapporten downloaden",
    "FILTER_DROPDOWN_LABEL": "Selecteer medewerker",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Gesprekken",
        "DESC": "( Totaal )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkomende berichten",
        "DESC": "( Totaal )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Uitgaande berichten",
        "DESC": "( Totaal )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Eerste reactietijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Eerste Reactie Tijd is {metricValue} (gebaseerd op {conversationCount} gesprekken)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolutie Tijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Afgelopen 7 dagen"
      },
      {
        "id": 1,
        "name": "Laatste 30 dagen"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Volg de prestaties van labels met belangrijke statistieken, zoals gesprekken, reactietijden, oplostijden en opgeloste zaken.",
    "LOADING_CHART": "Kaartgegevens laden...",
    "NO_ENOUGH_DATA": "We hebben niet genoeg datapunten ontvangen om een rapport te genereren, probeer het later opnieuw.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Gesprekken",
        "DESC": "( Totaal )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkomende berichten",
        "DESC": "( Totaal )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Uitgaande berichten",
        "DESC": "( Totaal )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Eerste reactietijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Eerste Reactie Tijd is {metricValue} (gebaseerd op {conversationCount} gesprekken)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolutie Tijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Afgelopen 7 dagen"
      },
      {
        "id": 1,
        "name": "Laatste 30 dagen"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Kaartgegevens laden...",
    "NO_ENOUGH_DATA": "We hebben niet genoeg datapunten ontvangen om een rapport te genereren, probeer het later opnieuw.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Selecteer een inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Gesprekken",
        "DESC": "( Totaal )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkomende berichten",
        "DESC": "( Totaal )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Uitgaande berichten",
        "DESC": "( Totaal )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Eerste reactietijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Eerste Reactie Tijd is {metricValue} (gebaseerd op {conversationCount} gesprekken)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolutie Tijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Afgelopen 7 dagen"
      },
      {
        "id": 1,
        "name": "Laatste 30 dagen"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Kaartgegevens laden...",
    "NO_ENOUGH_DATA": "We hebben niet genoeg datapunten ontvangen om een rapport te genereren, probeer het later opnieuw.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Gesprekken",
        "DESC": "( Totaal )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Inkomende berichten",
        "DESC": "( Totaal )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Uitgaande berichten",
        "DESC": "( Totaal )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Eerste reactietijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Eerste Reactie Tijd is {metricValue} (gebaseerd op {conversationCount} gesprekken)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Resolutie Tijd",
        "DESC": "(Gem. )",
        "INFO_TEXT": "Totaal aantal conversaties gebruikt voor berekening:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Aantal Resoluties",
        "DESC": "( Totaal )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Afgelopen 7 dagen"
      },
      {
        "id": 1,
        "name": "Laatste 30 dagen"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Beoordeling",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Aantal gesprekken",
        "TOOLTIP": "Totaal aantal gesprekken met botberichten"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Aantal antwoorden",
        "TOOLTIP": "Totaal aantal uitgaande berichten"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Aantal AI-antwoorden",
        "TOOLTIP": "Totaal aantal antwoordberichten verzonden door de bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Aantal voorbereide antwoorden",
        "TOOLTIP": "Totaal aantal copilot-suggesties die de bot heeft voorbereid voor agenten"
      },
      "SUCCESS_RATE": {
        "LABEL": "Opgelost door AI",
        "TOOLTIP": "Percentage gesprekken dat door AI is opgelost zonder overdracht aan een agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Resolutietijd",
        "TOOLTIP": "Mediane tijd tussen het eerste bericht van de klant en het laatste bericht van bot/agent"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Niet groeperen",
      "INBOXES": "Inboxen",
      "LABELS": "Labels"
    },
    "GROUPED": {
      "CHART_TITLE": "Verdeling per groep",
      "BACK_TO_ALL": "Alles tonen",
      "TABLE": {
        "INBOX": "Inbox",
        "LABEL": "Label",
        "CONVERSATIONS": "Gesprekken",
        "MESSAGES": "Berichten",
        "MESSAGES_TOOLTIP": "Totaal aantal uitgaande berichten",
        "AI_MESSAGES": "AI-antwoorden",
        "AI_MESSAGES_TOOLTIP": "Totaal aantal AI-antwoorden, gevolgd door het aantal positieve en negatieve beoordelingen van eindgebruikers",
        "THUMBS_UP_TOOLTIP": "Aantal AI-antwoorden dat door eindgebruikers positief is beoordeeld (duim omhoog)",
        "THUMBS_DOWN_TOOLTIP": "Aantal AI-antwoorden dat door eindgebruikers negatief is beoordeeld (duim omlaag)",
        "PREPARED": "Voorbereide antwoorden",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Percentage berichten van alle berichten dat tot deze groep behoort",
        "BOT_RESPONSES": "AI-antwoorden %",
        "SUGGESTION_USED": "Gebruikte antwoorden",
        "SUGGESTION_USED_TOOLTIP": "Percentage voorbereide antwoorden in deze groep dat door agenten is gebruikt",
        "SUGGESTION_NOT_USED": "Ongebruikte antwoorden",
        "SUGGESTION_NOT_USED_TOOLTIP": "Percentage berichten in deze groep waarvoor een voorbereid antwoord beschikbaar was, maar niet is gebruikt"
      },
      "NOTES": {
        "TITLE": "Hoe statistieken worden berekend",
        "CONVERSATIONS": "Aantal gesprekken met minstens één uitgaand bericht in de geselecteerde periode.",
        "MESSAGES": "Totaal aantal uitgaande (niet-privé) berichten verzonden in de geselecteerde periode. Dit omvat zowel door AI gegenereerde als door mensen geschreven berichten.",
        "PERCENTAGE": "Aandeel van de berichten van deze groep in alle uitgaande berichten van alle groepen.",
        "AI_MESSAGES": "Aantal uitgaande berichten dat automatisch is verzonden door de AI-bot (exclusief voorbereide antwoorden voor agenten). De getallen tussen haakjes tonen hoeveel van die antwoorden door eindgebruikers positief (duim omhoog) en negatief (duim omlaag) zijn beoordeeld.",
        "PREPARED": "Aantal copilot-suggesties (voorbereide antwoorden) die de AI-bot in de geselecteerde periode voor agenten heeft gegenereerd. Dit zijn privéberichten die alleen zichtbaar zijn voor agenten en niet meetellen als uitgaande berichten, dus dit aantal hoeft niet overeen te komen met de kolom Berichten.",
        "SUGGESTION_USED": "Percentage voorbereide antwoorden in deze groep dat door agenten is gebruikt. Dit hoeft niet overeen te komen met het aantal voorbereide antwoorden, omdat het ook suggesties kan omvatten die in eerdere periodes zijn gegenereerd.",
        "SUGGESTION_NOT_USED": "Percentage uitgaande berichten in deze groep waarbij een copilot-suggestie beschikbaar was, maar de agent zonder gebruik daarvan heeft geantwoord. Alleen geteld wanneer de agent daadwerkelijk een antwoord heeft verzonden. Dit hoeft niet overeen te komen met het aantal voorbereide antwoorden, omdat het ook suggesties kan omvatten die in eerdere periodes zijn gegenereerd."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Open",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Niet toegewezen",
      "PENDING": "Afwachtend"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Medewerker",
        "OPEN": "Open",
        "UNATTENDED": "Unattended",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Open",
        "UNATTENDED": "Onbeheer",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Online",
      "BUSY": "Bezig",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Filter toevoegen",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Geen resultaten gevonden",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent naam",
        "INBOXES": "Naam postvak",
        "LABELS": "Label naam",
        "TEAMS": "Team Naam"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Postvak In",
      "AGENTS": "Medewerker",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Gesprek",
        "AGENT": "Medewerker"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Subtotaal",
    "NO_TEAM": "Geen team",
    "GROUP_BY_TEAMS": "Groeperen op teams",
    "INBOX": "Postvak In",
    "AGENT": "Medewerker",
    "TEAM": "Team",
    "LABEL": "Label",
    "TOTAL": "Totaal",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Aantal Resoluties",
    "CONVERSATIONS": "Aantal conversaties",
    "OUTGOING_CHATS": "Uitgaande chats",
    "OUTGOING_EMAILS": "Uitgaande e-mails",
    "PHONE_CALLS": "Telefoongesprekken",
    "INBOUND_CALLS": "Inkomende oproepen",
    "OUTBOUND_CALLS": "Uitgaande oproepen",
    "TOTAL_ACTIVITIES": "Totaal aantal activiteiten",
    "ONLINE_TIME": "Online tijd",
    "QUEUE_AVAILABLE_TIME": "Beschikbare tijd in wachtrij",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Aantal uitgaande berichten verzonden door deze agent",
      "OUTGOING_EMAILS": "Aantal uitgaande e-mails verzonden door deze agent",
      "PHONE_CALLS": "Totaal aantal telefoongesprekken toegewezen aan deze agent (som van inkomende en uitgaande oproepen)",
      "TOTAL_ACTIVITIES": "Totaal aantal activiteiten: inkomende oproepen + uitgaande oproepen + uitgaande chats + uitgaande e-mails",
      "INBOUND_CALLS": "Aantal inkomende telefoongesprekken toegewezen aan deze agent",
      "OUTBOUND_CALLS": "Aantal uitgaande telefoongesprekken toegewezen aan deze agent",
      "AVG_FIRST_RESPONSE_TIME": "Gemiddelde tijd tussen het aanmaken van het gesprek en de eerste reactie van de agent, voor gesprekken die aan deze agent zijn toegewezen",
      "AVG_RESOLUTION_TIME": "Gemiddelde tijd tussen het aanmaken van het gesprek en het oplossen ervan, voor gesprekken die aan deze agent zijn toegewezen",
      "AVG_REPLY_TIME": "Gemiddelde tijd die klanten wachten tussen hun bericht en het antwoord van de agent, voor gesprekken die aan deze agent zijn toegewezen",
      "ONLINE_TIME": "Totale tijd dat de agent online of bezet was tijdens de geselecteerde periode",
      "QUEUE_AVAILABLE_TIME": "Totale tijd dat de agent beschikbaar was in telefoonwachtrijen tijdens de geselecteerde periode"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefoonrapporten",
    "DESCRIPTION": "Volg statistieken over telefoongesprekken met gedetailleerde inzichten in inkomende en uitgaande oproepen, gegroepeerd per agent of inbox voor uitgebreide analyse.",
    "DOWNLOAD_PHONE_REPORTS": "Telefoonrapporten downloaden",
    "GROUP_BY": {
      "LABEL": "Groeperen op",
      "AGENT": "Agent",
      "INBOX": "Inbox"
    },
    "TABLE": {
      "TOTAL_CALLS": "Totaal",
      "INBOUND_CALLS": "Inkomend",
      "OUTBOUND_CALLS": "Uitgaand",
      "FAILED_OUTBOUND_CALLS": "Mislukt uitgaand",
      "AVG_AGENT_HANDLED_DURATION": "Gem. duur",
      "TOTAL_AGENT_HANDLED_DURATION": "Totale duur",
      "AVG_RINGING_TIME": "Gem. beltijd",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Succes %",
      "UNIQUE_CALLERS": "Unieke bellers",
      "UNIQUE_CALLED_CONTACTS": "Uniek gebeld",
      "UNANSWERED_MISSED_CALLS": "Gemist zonder opvolging",
      "UNANSWERED_MISSED_PERCENTAGE": "Onbeantwoord gemist %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Gemist zonder opvolging, onvoldoende teruggebeld",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Gemist zonder opvolging, onvoldoende teruggebeld %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Totaal aantal oproepen (inclusief niet-verbonden)",
      "INBOUND_CALLS": "Aantal verbonden oproepen",
      "OUTBOUND_CALLS": "Aantal uitgaande oproepen (inclusief niet-verbonden)",
      "FAILED_OUTBOUND_CALLS": "Aantal uitgaande oproepen die niet konden worden verbonden",
      "AVG_AGENT_HANDLED_DURATION": "Gemiddelde duur van door agenten afgehandelde oproepen",
      "TOTAL_AGENT_HANDLED_DURATION": "Totale duur van alle door agenten afgehandelde oproepen",
      "AVG_RINGING_TIME": "Gemiddelde tijd dat oproepen overgingen voordat ze werden beantwoord",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percentage uitgaande oproepen dat succesvol werd verbonden",
      "UNIQUE_CALLERS": "Aantal unieke contacten dat inkomend heeft gebeld",
      "UNIQUE_CALLED_CONTACTS": "Aantal unieke contacten dat via uitgaande oproepen is gebeld",
      "UNANSWERED_MISSED_CALLS": "Aantal gemiste oproepen waarbij geen succesvol terugbelverzoek is gedaan (oproep verbonden). Kan oproepen bevatten die nog binnen de werkdag kunnen worden afgehandeld",
      "UNANSWERED_MISSED_PERCENTAGE": "Percentage unieke bellers van wie de oproep gemist werd zonder opvolging (onbeantwoord gemiste oproepen / unieke bellers)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Aantal gemiste oproepen met minder dan 2 terugbelpogingen. Kan oproepen bevatten die nog binnen de werkdag kunnen worden afgehandeld",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percentage unieke bellers met minder dan 2 terugbelpogingen ((gemist zonder opvolging - voldoende afgehandeld) / unieke bellers)"
    }
  }
}
